<template>
  <div class="keyboard-svg-wrapper">
    <keyboard-svg
      :class="classObj"
      :width="null"
      :height="null"
      viewBox="0 0 277 95"
    />
  </div>
</template>

<script>
/**
 * How-to map keys inside svg:
 * 1. load keyboard.vue.svg in browser
 * 2. find correct path using inspect element
 * 3. add relevant key-name as en attribute class="key-name" to element
 * 4. in order to apply changes - hit F2 copy html and paste into file.
 * 5. update css and relevant code with new key-name
 */

import KeyboardSvg from './svg/keyboard.vue.svg';

export default {
  name: 'keyboard-svg-wrapper',
  components: {
    KeyboardSvg,
  },

  props: {
    keys: { type: Array, required: false, default: () => [] },
  },

  computed: {
    classObj() {
      return this.keys;
    },
  },
};
</script>

<style lang="scss" scoped>
.keyboard-svg-wrapper {
  margin: 0 20px;

  .key-lsb .key-lsb,
  .key-rsb .key-rsb,
  .key-a .key-a,
  .key-i .key-i,
  .key-o .key-o,
  .key-rshift .key-rshift,
  .key-space .key-space,
  .key-larrow .key-larrow,
  .key-rarrow .key-rarrow {
    fill: #06a9f4;
  }
}
</style>
